import { filter, some } from 'lodash';
import type { IOrganizationIntegrationComms } from './OrganizationIntegrationComms.interface';

export default class OrganizationIntegrationComms implements IOrganizationIntegrationComms {
  apiId: string;
  authId: string;
  authToken: string;
  phones: Array<any>;
  useSms: boolean;
  usePhone: boolean;

  hasAuthentication() {
    return this.apiId && this.authId && this.authToken;
  }

  isEnabledSms() {
    return this.useSms === true && this.hasAuthentication();
  }

  isEnabledPhone() {
    return this.usePhone === true && this.hasAuthentication();
  }

  isEnabled() {
    return this.isEnabledSms() || this.isEnabledPhone();
  }

  hasPhonesInStock() {
    return this.phones?.length;
  }

  getPhonesForOwner(idOwner) {
    return filter(this.phones, (phone) => some(phone.idOwner, (id) => idOwner === id));
  }

  static build = (data: IOrganizationIntegrationComms) =>
    new OrganizationIntegrationComms(data);
  static blank = () => new OrganizationIntegrationComms();

  /**
   * Constructor
   * @param {IOrganizationIntegrationComms} data
   */
  constructor(data?: IOrganizationIntegrationComms) {
    this.apiId = data?.apiId || undefined;
    this.authId = data?.authId || undefined;
    this.authToken = data?.authToken || undefined;
    this.phones = data?.phones || [];
    this.useSms = data?.useSms === true;
    this.usePhone = data?.usePhone === true;
  }
}
